import MediaEmbed from 'umg-ember-backend/components/record-explorer/for/media-embed';

<template>
  <MediaEmbed @records={{@model}} @recordType='media-embed' />
</template>
